import { render, staticRenderFns } from "./return-bodyprint-modal.vue?vue&type=template&id=33f2bbd8"
import script from "./return-bodyprint-modal.vue?vue&type=script&lang=js"
export * from "./return-bodyprint-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports